// Copyright (c) Docugami, Inc. All rights reserved.

import { DirectionalHint, TooltipHost } from "@fluentui/react";
import { DgButton } from "components/common/DgCommonStyledComponents";
import { useAppDispatch, useAppSelector } from "hooks/redux";
import { setChatSession } from "store/chat/chatSlice";
import { createSelectHasSessionMessages } from "store/chat/selectors";
import { selectChatOptions } from "./ChatView";

interface ChatSessionButtonProps {
    docSetId: string;
}

const selectHasSessionHistory = createSelectHasSessionMessages();
export const ChatSessionButton = (props: ChatSessionButtonProps): JSX.Element => {
    const chatOptions = useAppSelector(state => selectChatOptions(state, props.docSetId));
    const currentSessionId = useAppSelector(state => state.chatSlice.chatSessions[props.docSetId]);
    const disabled = useAppSelector(state => !selectHasSessionHistory(state, chatOptions, currentSessionId));

    const dispatch = useAppDispatch();

    function startNewSession() {
        // We start a new session by unsetting the current session state
        dispatch(setChatSession({ docSetId: props.docSetId, sessionId: undefined }));
    }

    return (
        <TooltipHost styles={{ root: { display: 'flex' }}} content="Start new session" directionalHint={DirectionalHint.bottomCenter}>
            <DgButton disabled={disabled} onClick={startNewSession}>+</DgButton>
        </TooltipHost>
    )
}